import axios from './axios';

export const getOrderInsight = () => {
  return axios.get('/admin/insight/pesanan');
};

export const getTagihanInsight = () => {
  return axios.get(`/admin/insight/tagihan`);
};
